module.exports = __webpack_public_path__ + "static/media/Metropolis Regular-01.7d73ed7f.svg";